import { Box } from '@mui/material';
import { startCase } from 'lodash';

import { isDefined } from 'common';

import { FlowTemplateCardPlaceholderIcon } from './Placeholder';
import { FlowTemplateCardUseCaseSvgIconMap, isKnownFlowTemplateCardUseCase } from './SvgIcons';
import { getFlowTemplateCardColors } from '../colors';

interface FlowTemplateCardUseCaseIconProps {
  useCase?: string;
  solutionArea?: string;
  size?: number;
}

interface FlowTemplateCardUseCaseIconSvgProps {
  useCase?: string;
  iconSize: number;
}

function FlowTemplateCardUseCaseIconSvg(props: FlowTemplateCardUseCaseIconSvgProps) {
  const { useCase, iconSize } = props;

  if (!isDefined(useCase) || !isKnownFlowTemplateCardUseCase(useCase)) {
    return <FlowTemplateCardPlaceholderIcon title="Unknown Use Case" sx={{ fontSize: iconSize }} />;
  }

  const UseCaseIcon = FlowTemplateCardUseCaseSvgIconMap[useCase];
  return <UseCaseIcon fontSize={iconSize} title={startCase(useCase)} />;
}

export function FlowTemplateCardUseCaseIcon(props: FlowTemplateCardUseCaseIconProps) {
  const { useCase, solutionArea, size = 40 } = props;
  const iconSize = size - 16;

  const colors = getFlowTemplateCardColors({ solutionArea });
  const background = `linear-gradient(to right, ${colors.dark}, ${colors.light})`;

  return (
    <Box
      sx={{
        width: size,
        height: size,
        background,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 2,
      }}
    >
      <FlowTemplateCardUseCaseIconSvg useCase={useCase} iconSize={iconSize} />
    </Box>
  );
}
